<template>
    <li v-if="message.message == 'lot_announce'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no }) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_announce_recall'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no }) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_announce_back_to_auction'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no }) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_open'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no, ask: message.params.k }) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_open_winner'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { paddle: message.params.w, curent: message.params.p }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_reserve'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, {  }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_sell_congrats'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_sell'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_pass'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_pass_reserve'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_reset'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'bid_win_congrats'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { value: message.params.a }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'bid_win'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { paddle: message.params.w.w ? message.params.w.w : message.params.w, ask: message.params.p }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'bid_outbid'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'price_changed'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { price: message.params.p }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'ask_spit'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { ask: message.params.k }) }}</div>
    </li>

    <li v-else-if="message.message == 'ask_changed'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { ask: message.params.k }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'bid_receive'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { paddle: message.params.w, ask: message.params.k }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_warn'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_warn_fairwarningclose'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_warn_once'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_warn_twice'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`) }}</div>
    </li>

    <li v-else-if="message.message == 'lot_warn_seconds'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { seconds: message.params.p  }) }}</div>
    </li>
    
    <li v-else-if="message.message == 'lot_recall'" class="flex items-center w-full bg-gray-100 rounded-lg">
        <div class="p-2 flex-1">{{ $t(`messages.${message.message}`, { lot: message.params.no, paddle: message.params.u}) }}</div>
    </li>

</template>

<script>
export default {
    props: [ 'message' ],
}
</script>

<style scoped>
    .neutral-bg {
        background-color: gray;
    }

    .win-bg {
        background-color: green;
    }

    .loose-bg {
        background-color: red;
    }

    .neutral {
        width: 0; 
        height: 0; 
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid gray;
    }

    .win {
        width: 0; 
        height: 0; 
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid green;
    }

    .loose {
        width: 0; 
        height: 0; 
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid red;
    }
</style>